import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationSearchContainer from '../LocationSearchContainer';
import LandingPageFooter from '../../components/LandingPageFooter';
import i18n from '../../utils/i18n';

export function CuisinePageFooterContainer({ isPostcodeSearch, cuisineName }) {
  const locationSearch = (
    <LocationSearchContainer
      caption={i18n.gettext(
        `landingPage.cuisine.locationSearch.input.${
          isPostcodeSearch ? 'postcode' : 'formattedAddress'
        }.label(%(cuisine)s)`,
        { cuisine: cuisineName },
      )}
      searchType="restaurants"
      searchFilter={{
        tags: cuisineName.toLowerCase(),
      }}
      trackingPage="Cuisine Landing Page (footer)"
      isModal={false}
    />
  );

  return (
    <LandingPageFooter
      heading={i18n.gettext('landingPage.cuisine.footer.locationSearch.title')}
      locationSearch={locationSearch}
    />
  );
}

CuisinePageFooterContainer.propTypes = {
  isPostcodeSearch: PropTypes.bool.isRequired,
  cuisineName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const { postcodeSearch: isPostcodeSearch } = state.request.country;
  const { cuisine: cuisineName } = state.cuisine;

  return {
    isPostcodeSearch,
    cuisineName,
  };
};

export default connect(mapStateToProps)(CuisinePageFooterContainer);
